import type { SkillMemoryRepository } from "@/domain/learning/skill-memory-repository";
import { isStorageAvailable } from "./progress-repository-factory";
import {
  InMemorySkillMemoryRepository,
  LocalStorageSkillMemoryRepository,
} from "./skill-memory-repository";

export function createSkillMemoryRepository(
  storage: Storage = window.localStorage,
): SkillMemoryRepository {
  return isStorageAvailable(storage)
    ? new LocalStorageSkillMemoryRepository(storage)
    : new InMemorySkillMemoryRepository();
}
